module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: {
      'has-error': _vm.hasError
    }
  }, [_vm._t("label"), _vm._v(" "), _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    class: _vm.classes,
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  }, 'input', _vm.attrs, false), _vm.listeners)), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.messageError) + "\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7127426"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/VUploadField.vue
// module id = 1718
// module chunks = 1